import { Table } from 'docx'
import { ProcessingState, ProcessingContext, TableProcessorResult } from '../types'
import { createTable } from '../utils/createTable'

/**
 * Process table and return table paragraph or null
 */
export function processTable(
  lines: string[],
  currentIndex: number,
  state: ProcessingState,
  context: ProcessingContext
): TableProcessorResult {
  const trimmedLine = lines[currentIndex].trim()
  
  if (trimmedLine.includes('|') && !state.isInTable) {
    state.isInTable = true
    const tableRows: string[][] = []
    let tableHeaders: string[] = []
    let i = currentIndex
    
    while (i < lines.length && lines[i].trim().includes('|')) {
      const tableLine = lines[i].trim()
      if (tableLine.match(/^\|.*\|$/)) {
        const cells = tableLine.split('|').map(cell => cell.trim()).filter(cell => cell)
        
        if (!cells.every(cell => cell.match(/^-+$/))) {
          if (tableRows.length === 0) {
            tableHeaders = cells
          } else {
            tableRows.push(cells)
          }
        }
      }
      i++
    }
    
    state.isInTable = false
    if (tableHeaders.length > 0) {
      return { 
        paragraph: createTable(tableHeaders, tableRows, context.font, context.fontSize), 
        newIndex: i 
      }
    }
    return { paragraph: null, newIndex: i }
  }

  if (state.isInTable && !trimmedLine.includes('|')) {
    state.isInTable = false
  }

  return { paragraph: null, newIndex: currentIndex }
}